/**
 * SMS Help Page
 * Issue #1320: SMS HELP compliance for 10DLC
 *
 * Required for TextGrid campaign registration. Serves as:
 * - User-facing help for SMS questions
 * - Audit evidence for carrier compliance
 *
 * Content lives in data/content/smsHelp.ts (#2212 — shared with the
 * native SMS Help screen).
 */

import PageLayout from '../components/PageLayout';
import ContentDocView from '../components/ContentDocView';
import { SMS_HELP_DOC } from '../data/content/smsHelp';

export default function SmsHelpPage() {
  return (
    <PageLayout title="SMS Help">
      <ContentDocView doc={SMS_HELP_DOC} />
    </PageLayout>
  );
}
